// extracted by mini-css-extract-plugin
export default {"dropdown":"index_dropdown_dT4GR","icon":"index_icon_iCsy8"};